import logo from '../assets/Logo.svg';

const Logo = () => {
  return <img className="h-24 mx-auto" src={logo} alt="LastLap Logo" />;
};

export default Logo;
